"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDate = exports.INPUT_DATE_PATTERN = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var IconCalender_1 = require("../icon/IconCalender");
var InputText_1 = require("./InputText");
exports.INPUT_DATE_PATTERN = /\d{4}-\d{2}-\d{2}$/;
var colors = {
    blue: 'br-text-blue-600',
    gray: 'br-text-gray-800',
    green: 'br-text-green-400'
};
var colorsDisabled = {
    blue: 'br-text-blue-200',
    gray: 'br-text-gray-500',
    green: 'br-text-green-100'
};
var InputDate = function (_a) {
    var onChange = _a.onChange, _b = _a.calenderColor, calenderColor = _b === void 0 ? 'blue' : _b, props = __rest(_a, ["onChange", "calenderColor"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("label", { className: (0, classnames_1.default)('br-relative') },
            react_1.default.createElement(InputText_1.InputText, __assign({ type: "date", 
                // Show a placeholder for browsers that fall back to a text input
                // NOTE: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date#handling_browser_support
                placeholder: "yyyy-mm-dd", onChange: function (value) {
                    // NOTE: when browsers fall back to text input, do not trigger on change event unless date is in correct format
                    if (exports.INPUT_DATE_PATTERN.test(value) && onChange) {
                        onChange(value);
                    }
                } }, props, { className: (0, classnames_1.default)('brenger-calendar', props.className) })),
            react_1.default.createElement(IconCalender_1.IconCalender
            // bg-white to hide a clear button in Firefox
            , { 
                // bg-white to hide a clear button in Firefox
                className: (0, classnames_1.default)('br-absolute', 'br-pointer-events-none', 'br-bg-white', props.disabled ? colorsDisabled[calenderColor] : colors[calenderColor]), style: {
                    // To hide a clear button in Firefox
                    top: '0.15em',
                    right: '0.75em',
                    zIndex: 1
                } }))));
};
exports.InputDate = InputDate;
